import { render } from "./DoctorRequests.vue?vue&type=template&id=42c39c80&scoped=true"
import script from "./DoctorRequests.vue?vue&type=script&lang=js"
export * from "./DoctorRequests.vue?vue&type=script&lang=js"

import "./DoctorRequests.vue?vue&type=style&index=0&id=42c39c80&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-42c39c80"]])

export default __exports__